import styled from 'styled-components'

import { MEDIA_QUERY } from '../../../styles'
import { fieldWidth } from '../constants'
import * as InputStyles from '../input.styled'
import { FieldWidthType } from '../types'
import CalendarSvg from './calendar.svg'

export const Container = styled.div<{ $valueWidth?: FieldWidthType; $responsive: boolean }>`
  position: relative;
  min-height: 44px;
  max-width: ${({ $valueWidth }) => ($valueWidth ? fieldWidth[$valueWidth] : '420px')};
  @media (max-width: 420px) {
    width: 100%;
    max-width: ${({ $responsive }) => $responsive && '100%'};
  }
`

export const DatepickerWrapper = styled.div`
  position: relative;
`

export const DatepickerContainer = styled.div`
  position: absolute;
  z-index: 100;
  top: 10px;
  @media ${MEDIA_QUERY.MOBILE} {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
  }
`

export const CalendarIco = styled.button`
  background: url(${CalendarSvg}) center center no-repeat;
  background-size: 22px 20px;
  width: 22px;
  height: 20px;
  cursor: pointer;
  padding: 0 20px;
  border: none;
`

export const Input = styled(InputStyles.Input)`
  &:focus {
    outline: none;
  }
`

export const InputContainer = styled(InputStyles.InputContainer)`
  background-color: ${({ theme }) => theme.colors.input.white};

  &:has(input[type='text']:disabled) {
    #calendar-ico,
    input[type='text']:disabled {
      cursor: not-allowed;
    }

    background-color: ${({ theme }) => theme.colors.input.disabled};
  }

  &:focus-within {
    border: 1px solid transparent;
    outline: 2px solid ${({ theme }) => theme.colors.input.active};
  }
`
